import * as React from "react";
import { BaseFieldEditor } from "./helper";
import { FieldValueText } from "typings";
import { Label } from "office-ui-fabric-react";

export interface Props extends BaseFieldEditor
{
    value: FieldValueText;
    placeholder?: string;
}

interface State
{
    
}

class LabelRender extends React.Component<Props, State>
{
    render()
    {
        const unit = this.props.field.unit;
        const unitLabel = unit ? <Label>{this.props.field.unit}</Label> : null;
        const value = this.props.value ? this.props.value.value : "";
        return (
            <div>
                <Label>{value}</Label>
                {unitLabel}
            </div>
        );
    }
}

export default LabelRender;


// WEBPACK FOOTER //
// ./src/components/product/FieldEditor/Label.tsx